export default __webpack_public_path__ + "static/media/MEN.7f34148c.png";